module.exports = __webpack_public_path__ + "img/table.d38299ea.png";